export default __webpack_public_path__ + "mark_4.mp4";